/**
 * av-reveal.js
 * Shared scroll-reveal enhancement for the Ascari Vintage Racer campaign
 * sections. Loaded (with `defer`) by any section that renders elements
 * carrying [data-av-reveal]. Safe to include from multiple sections on the
 * same page — initialization is idempotent and guarded behind a single
 * global flag, so it only ever attaches one observer regardless of how many
 * sections reference this file.
 *
 * Progressive enhancement: av-shared.css renders [data-av-reveal] fully
 * visible by default. Only once this script confirms IntersectionObserver
 * support does it arm the hidden state (via the `data-av-reveal-armed`
 * attribute on <html>), so content is never dependent on JS to be visible.
 */
(function () {
  if (window.__avRevealInit) return;
  window.__avRevealInit = true;

  if (!('IntersectionObserver' in window)) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  var root = document.documentElement;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
  );

  function observeAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-av-reveal]:not(.is-visible)');
    nodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  root.setAttribute('data-av-reveal-armed', '');
  observeAll();

  // Re-scan when the Theme Editor injects a new/duplicated section.
  document.addEventListener('shopify:section:load', function (event) {
    observeAll(event.target);
  });
})();
